// extracted by mini-css-extract-plugin
module.exports = {"actionsHeader":"styles_actionsHeader__23ye8","compactHeader":"styles_compactHeader__JJE7a","divider":"styles_divider__G8atk","compact":"styles_compact__ENEeY"};